import AuthenticationContext, { UserInfo as AzureADUserInfo } from 'adal-angular';
import AuthConfig from './AuthConfig';
import { AppStoreModule } from '../../store';
import IAuthService from './IAuthService';
import AppStore from '@/store/modules/AppStoreModule';

export default class AuthService implements IAuthService {
  private azureAuthContext: AuthenticationContext;
  private authConfig: AuthConfig;

  private app$: AppStore = AppStoreModule;

  constructor(authConfig: AuthConfig) {
    this.authConfig = authConfig;
    this.azureAuthContext = new AuthenticationContext({...this.authConfig});
  }

  checkAuthenticationSession(): Promise<void> {
    return new Promise<void>((resolve) => {
      if (this.azureAuthContext.isCallback(window.location.hash) || window.self !== window.top) {
        // redirect to the location specified in the url params.
        this.azureAuthContext.handleWindowCallback();
      } else {
        if (this.getAuthenticatedUser()) {
          return resolve();
        } else {
          this.login();
        }
      }
    });
  }

  getAccessToken(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      if (!this.isAuthenticated()) {
        return reject('You are not logged in.');
      } else {
        this.azureAuthContext.acquireToken(this.authConfig.resourceId, (error: string | null, token: string | null) => {
          if (error || !token) {
            this.azureAuthContext.acquireTokenRedirect(this.authConfig.resourceId, null, null);
          } else {
            return resolve(token);
          }
        });
      }
    });
  }

  login(): void {
    if (!this.isAuthenticated()) {
      this.azureAuthContext.login();
    }
  }

  logout(): void {
    this.app$.logout();
    this.azureAuthContext.logOut();
  }

  getAuthenticatedUser(): AzureADUserInfo {
    return this.azureAuthContext.getCachedUser();
  }

  isAuthenticated(): boolean {
    if (this.azureAuthContext.getCachedToken(this.authConfig.clientId)) {
      return true;
    } else {
      return false;
    }
  }
}
